module.exports = __webpack_public_path__ + "img/41.c50380d8.jpg";